<script>
const Login = {
  methods: {
    async validateRedirect(result) {
      if (result) {
        const hasPayPermission = result.current_user.permission_list.includes('view_pay');
        const hasBidsPermission = result.current_user.permission_list.includes('view_bids');
        const hasTrackingPermission = result.current_user.permission_list.includes('view_tracking');
        const hasIndentsPermission = result.current_user.permission_list.includes('view_indents');
        const hasHistoricIndentsPermission = result.current_user.permission_list.includes('view_historic_indents');
        const currentClient = result.clients && result.clients[0];
        const hasPayV2Feature = currentClient && currentClient.features.includes('payments_v2');
        const passwordToBeReset = result.current_user.reset_password;
        const resetPasswordReason = result.current_user.reset_password_reason || '';
        if (passwordToBeReset) {
          this.$store.commit('app/SET_FILTER_VISIBILITY', true);
          this.$router.push({ name: 'ResetPassword', params: { resetPasswordReason } });
          return;
        }
        this.$store.commit('app/SET_FILTER_VISIBILITY', false);
        if (hasIndentsPermission) {
          this.$router.push({ name: 'IndentsList' });
        } else if (hasHistoricIndentsPermission) {
          this.$router.push({ name: 'HistoricIndentsList' });
        } else if (hasPayPermission) {
          if (hasPayV2Feature) {
            this.$router.push({ name: 'payments' });
          } else {
            this.$router.push({ name: 'PaymentList' });
          }
        } else if (hasBidsPermission) {
          this.$router.push({ name: 'RfqList' });
        } else if (hasTrackingPermission) {
          this.$router.push({ name: 'Tracking' });
        }
        if (
          result.current_user &&
          result.current_user.inlineManual[0] &&
          result.current_user.inlineManual[0].transporter_api_key
        ) {
          this.initializeInlineManual(result.current_user.inlineManual[0].transporter_api_key);
          window.inlineManualTracking = {
            uid: result.current_user.id,
            email: result.current_user.email,
            name: result.current_user.name,
          };
          // lazy loading the inline manual initializaion
          const id = setInterval(() => {
            const check = this.createmanual();
            if (check) {
              clearInterval(id);
            }
          }, 5000);
        }
        if (result.current_user && !result.current_user.has_accepted_terms_conditions &&
          result.client_config[0].terms_and_conditions &&
          result.client_config[0].terms_and_conditions.transporter_is_enabled) {
          this.$store.commit('app/SHOW_TERMS_DIALOG', true);
        }
      }
    },
    initializeInlineManual(apiKey) {
      try {
        const inlineWriterScriptElement = document.createElement('script');
        const t = document.getElementsByTagName('script')[0];
        inlineWriterScriptElement.setAttribute('async', 1);
        inlineWriterScriptElement.setAttribute('charset', 'UTF-8');
        t.parentNode.insertBefore(inlineWriterScriptElement, t);
        const baseUrl = this.environmentVariables.il_ml_base_url.replace('API_KEY', apiKey);
        inlineWriterScriptElement.setAttribute('src', baseUrl);
        document.head.appendChild(inlineWriterScriptElement);
      } catch (error) {
        console.log('Inline Manual Initialization Failed', error);
      }
    },
    createmanual() {
      try {
        // eslint-disable-next-line no-undef
        createInlineManualPlayer(window.inlineManualPlayerData);
        return true;
      } catch (error) {
        console.log('Error occured while initializing inline manual', error);
        return false;
      }
    },
  },
};
export default Login;
</script>
